import { registerSystem } from "yage/components/ComponentRegistry";
import { System } from "yage/components/System";
import { PlayerTypeSchema, EnemyTypeSchema } from "yage/components/entity/Types";
import { Component, Schema, defaultValue, type } from "yage/decorators/type";
import { GameModel } from "yage/game/GameModel";
import { ChildSchema } from "yage/schemas/entity/Child";
import { getPlayerCharacter } from "../../utils/playerCharacter";

@Component("ShareOnDeath")
export class ShareOnDeathSchema extends Schema {
  @type(["number"])
  @defaultValue([])
  entities: number[];

  @type("number")
  @defaultValue(-1)
  owner: number;

  @type("number")
  @defaultValue(-1)
  killedEntity: number;

  @type("number")
  @defaultValue(-1)
  killSource: number;
}

class ShareOnDeathSystem implements System {
  schema = ShareOnDeathSchema;
  type = "ShareOnDeath";
  dependencies = ["Child"];

  init(entity: number, gameModel: GameModel) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      let parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      if (gameModel.hasComponent(parent, "PlayerInput")) {
        parent = getPlayerCharacter(parent, gameModel);
      }
      gameModel.addIfMissing(parent, ShareOnDeathSchema);
      const parentData = gameModel.getTypedUnsafe(parent, ShareOnDeathSchema);
      parentData.entities.push(entity);
    }
  }
}

registerSystem(ShareOnDeathSystem);
